<template>
  <v-card flat class="product-view">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pt-0 pb-1">
      <v-row>
        <v-col cols="6" class="pb-0 pt-0">{{ orderModel.number }}</v-col>
        <v-col cols="6" class="pb-0 pt-0 text-right">{{ $t('message.order.delivery') }}: {{ orderModel.deliverydate | dateFormat }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="8" class="pa-0 pl-3">{{ orderModel.customer_name || '' }}</v-col>
        <v-col cols="4" class="pa-0 text-right font-weight-bold pl-3">{{ $t('message.order.total') }}:</v-col>
      </v-row>
      <v-row>
        <v-col cols="8" class="pa-0 pl-3">{{ orderModel.customeraddress_address || '' }}</v-col>
        <v-col cols="4" class="pa-0 text-right font-weight-bold pl-3">{{ grandTotal | absoluteNumber }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0 pl-3">{{ orderModel.customeraddress_address2 || '' }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0 pl-3">{{ orderModel.customeraddress_postcode || '' }} {{ orderModel.customeraddress_city || '' }}</v-col>
      </v-row>
    </v-card-text>
    <v-card-text class="highlight pt-0 pb-0 pl-1">
      <v-row>
        <v-col cols="3" class="pa-0 pl-3 font-weight-bold">{{ $t('message.order.picked') }}:</v-col>
        <v-col cols="3" class="pa-0 pr-2 text-center font-weight-bold">{{ $t('message.order.location') }}</v-col>
        <v-col cols="2" class="pa-0 text-right font-weight-bold">{{ $t('message.product.qty') }}</v-col>
        <v-col cols="4" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.price') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in listOfProducts" :key="index">
        <v-col cols="3" class="pa-0 pl-3 text-truncate" :title="product.number" :class="{ 'pb-1': (index === listOfProducts.length - 1)}">
          <span v-if="product.ispackage"><b>{{ product.number }}</b></span>
          <span v-else>{{ product.number }}</span>
        </v-col>
        <v-col cols="3" class="pa-0 text-center text-truncate" :title="product.locationname">{{ product.locationname }}</v-col>
        <v-col cols="2" class="pa-0 text-right text-truncate" :title="product.qty">{{ product.qty | absoluteNumber }}</v-col>
        <v-col cols="4" class="pa-0 pl-3 text-right text-truncate">
          {{ product.total | absoluteNumber }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="pickOrderHandler">{{ $t('message.order.pickOrder') }}</v-btn>
      <v-btn color="primary" @click="completeOrder">{{ $t('message.order.complete') }}</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
    <!-- Freight adding  -->
    <v-dialog v-model="freightObj.dialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.confirmation') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.order.addFreight') }}
          <v-form ref="freightForm">
            <v-row>
              <v-col cols="6">
                <v-text-field dense hide-details v-model="cost" :rules="$_norwegianNumberValidation"
                outlined :label="$t('message.order.cost')"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field dense hide-details v-model="price" :rules="$_norwegianNumberValidation"
                outlined :label="$t('message.order.price')"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="freightConfirm" :loading="freightObj.loading" @click="freightObj.onSuccess">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="primary" id="freightClose" @click="freightObj.onClose">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      orderId: 0,
      listOfProducts: [],
      orderModel: {},
      cost: '',
      price: '',
      grandTotal: 0,
      freightObj: {}
    }
  },
  mounted () {
    this.loading = true
    this.orderId = this.$route.params.store_id
    this.getMaterialProducts()
    this.getOrderInfo()
  },
  methods: {
    getOrderInfo () {
      let model = {
        'expand': [{
          'select': ['name'],
          'model': 'Customer',
          'on_field': 'id',
          'on_parent_field': 'customerid'
        }, {
          'select': ['address', 'address2', 'postcode', 'city'],
          'model': 'CustomerAddress',
          'on_field': 'id',
          'on_parent_field': 'deliveryaddress'
        }],
        'filter': `id eq '${this.orderId}'`
      }
      this.$api.execute('post', 'orders/query', model)
        .then((response) => {
          if (response.data) {
            this.orderModel = response.data[0]
          }
        })
    },
    getMaterialProducts () {
      this.$api.execute('get', `/ordermaterials/get_materials/${this.orderId}`)
        .then((response) => {
          if (response.data) {
            let list = response.data
            this.listOfProducts = list.pickedproducts
            let items = this.$format.cloneVariable(list.pickedproducts)
            this.grandTotal = 0
            items.map(x => {
              if (!x.packageid && !x.orderindex && !x.mainpackageid) {
                this.grandTotal += (x.total || 0)
              }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    pickOrderHandler () {
      this.$router.push(`/store_sale/${this.orderId}/pick`)
    },
    completeOrder () {
      this.freightObj = {
        dialog: true,
        onSuccess: () => {
          this.freightObj.loading = true
          this.addFrieghtHandler(true)
        },
        onClose: () => {
          this.addFrieghtHandler(false)
        }
      }
    },
    addFrieghtHandler (type) {
      if (this.$refs.freightForm.validate()) {
        const model = this.$format.cloneVariable(this.orderModel)
        model.orderid = model.id
        model.id = 0
        model.costprice = this.$format.replaceCommaWithDot(this.cost)
        model.total = this.$format.replaceCommaWithDot(this.price)
        model.price = this.$format.replaceCommaWithDot(this.price)
        this.freightObj.loading = false
        this.freightObj.dialog = false
        this.$api.execute('post', `ordermaterials/add_freight?add_row=${type}`, model)
          .then((response) => {
            this.freightObj.loading = false
            this.freightObj.dialog = false
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.order.completedSuccess') })
            this.$router.push('/store_sale')
          })
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        this.freightObj.loading = false
      }
    }
  }
}
</script>
